import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://wsmcegammgydbkylevfb.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndzbWNlZ2FtbWd5ZGJreWxldmZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgxNjcwNTYsImV4cCI6MjA5Mzc0MzA1Nn0.my1KVFXXkghIaiAvlt5dFKjLOFBotF-yrpbE4FFIGMQ'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})